import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _headerText;

import React from 'react';
var ATTRIBUTE_TYPE = {
  FABRIC_TYPE: 'fabric type',
  FEET_COLOUR: 'feet colour',
  FABRIC_INFO: 'fabric-info'
}; // The Drawer Header text for each attribute type

var headerText = (_headerText = {}, _defineProperty(_headerText, ATTRIBUTE_TYPE.FABRIC_TYPE, 'Choose your fabric and colour'), _defineProperty(_headerText, ATTRIBUTE_TYPE.FEET_COLOUR, 'Choose your legs finish'), _defineProperty(_headerText, ATTRIBUTE_TYPE.FABRIC_INFO, 'Choose your fabric and colour'), _headerText);
var aboutFabricText = 'About our fabrics';
var fabrics = [{
  heading: 'Flat Weave',
  description: 'With a hint of texture and an understated fusion of tonal colours, our flat weave fabrics are smoothly subtle.',
  composition: '100% Polyester',
  tags: []
}, {
  heading: 'Textured Weave',
  description: 'Our textured weave fabrics are comfortably tactile. Muted tonal colours are interwoven creating a soft boucle feel.',
  composition: '100% Polyester',
  tags: []
}, {
  heading: 'Chenille',
  description: 'Our chenille textiles have a gentle velvety sheen that brings out the depth of colour. A softly strokable but durable fabric.',
  composition: '100% Polyester',
  tags: []
}, {
  heading: 'Velvet',
  description: 'A classic choice. Our short pile velvet is made from 100% recycled polyester with the traditional soft richness that velvet is famous for.',
  composition: '100% Polyester',
  tags: ['100% Recycled Material']
}, {
  heading: 'Aquaclean Chenille',
  description: "Our Aquaclean\xAE Chenille is a firm favourite with a soft matt appearance and incredible durability. Using Aquaclean\xAE technology is also super practical. Most household stains can be removed simply by using a little water. Including wine, sauce, grease, mud, chocolate and cream.  In other words, it\u2019s a pet-friendly, family-friendly, accidental-spills friendly, fabric.\n\nKnowing pets are part of the family it\u2019s important the sofa works for all of you. That\u2019s why our Acquaclean\xAE Chenille is a top choice for keeping your sofa clean and fresh. Having stain resistant technology built into the fabric means you can wipe away muddy paw marks and eliminate pet odours with just water.",
  composition: '100% Polyester',
  tags: ['Pet Friendly', 'Family Friendly']
}];
var fabricDescription = /*#__PURE__*/React.createElement("span", null, "You can now order up to 5 free fabric samples");
export { ATTRIBUTE_TYPE, headerText, fabrics, fabricDescription, aboutFabricText };